export default {
    namespaced: true,
    state: {
        items: [],
        oneItem: {},
        chapters: [],
    },
    mutations: {
        setItems: (state, payload) => state.items = payload,
        setOneItem: (state, payload) => state.oneItem = payload,
        setChapters: (state, payload) => state.chapters = payload,
    },
    actions: {
        getItems: ({state, commit}) => {
            return axios({url: '/faq', method: 'GET' })
                .then(resp => {
                    commit('setItems', resp.data.items)
                })
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных.')
                })
        },
        getItemOne: ({state, commit}, id) => {
            return axios({url: '/info/faq-settings/edit/' + id, data: id, method: 'GET' })
                .then(resp => {
                    commit('setOneItem', resp.data)
                })
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных ответа.')
                })
        },
        updateItem: ({state, commit}, data) => {
            return axios({url: '/info/faq-settings/update/', data: data, method: 'POST' })
                .then(resp => {
                    // commit('', resp.data)
                })
                .catch(err => {
                    console.log('Произошла ошибка при сохранении данных ответа.')
                })
        },
        newItem: ({state, commit}, data) => {
            return axios({url: '/info/faq-settings/new/', data: data, method: 'POST' })
                .then(resp => {
                    // commit('', resp.data)
                })
                .catch(err => {
                    console.log('Произошла ошибка при создании ответа.')
                })
        },
        fetchChapters: ({state, commit}) => {
            return axios.get('/faqChapters')
                .then(resp => {
                    commit('setChapters', resp.data)
                })
                .catch(err => console.log(err))
        },
        newChapter: ({state, commit}, title) => {
            return axios.post('/info/faq-settings/newChapter', { title: title })
                .then(resp => {
                })
                .catch(err => console.log(err))
        },
        deleteChapter: ({state, commit}, id) => {
            return axios.post('/info/faq-settings/deleteChapter', { id: id })
                .then(resp => {
                })
                .catch(err => console.log(err))
        },
        updateChapter: ({state, commit}, data) => {
            return axios.post('/info/faq-settings/updateChapter', { data: data })
                .then(resp => {
                    commit('setChapters', resp.data)
                })
                .catch(err => console.log(err))
        },
    },
    getters: {
        DATA_ITEMS: state => state.items,
        DATA_ONE_ITEM: state => state.oneItem,
        DATA_CHAPTERS: state => state.chapters,
    }
}
